module.exports = __webpack_public_path__ + "img/logo-color@3x.faacecd7.png";